export default "__VITE_ASSET__3H1RUroY__"